import React from 'react';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { Tooltip } from '@material-ui/core';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

const Burnout = ({ name, isWipOverload, isTopReviewer }) => {
  const showBurnoutText = !isTopReviewer && !isWipOverload;
  return (
    <>
      {showBurnoutText && (
        <Text
          size='large'
          weight={400}
          data-testid='Burnout-text'
          className='status-text'
        >
          Burnout risk
        </Text>
      )}
      <Tooltip
        title={
          <Flex padding='tooltip' direction='column'>
            <Flex items='center' pb='small'>
              <Icon name='burnout' color='terracotta' size='medium' />
              <Text pl='0.5rem' size='medium' weight={500} color='shark'>
                Burnout Alert!
              </Text>
            </Flex>
            <Text
              color='shuttleGray'
              size='medium'
              data-testid='Burnout-tooltip-text'
            >
              Is {name} taking time to rest? Check in with them.
            </Text>
          </Flex>
        }
      >
        <StyledIcon name='burnout' color='terracotta' size='large' />
      </Tooltip>
    </>
  );
};

export default Burnout;
